import { useEffect, useState } from "react";
import { InputField, mapSelectOptionsNormalizedValue, SelectField, SelectOption } from "../../Form";
import { LoadingWrapper } from "../../LoadingWrapper";
import { Typography, Grid } from "@mui/material";
import { Form, Field, FieldProps } from "react-final-form";
import { LoadingButton } from "@mui/lab";
import { useSlideInContext } from "../SlideInProvider";
export type CustomFieldPayload = {
    type: string,
    position: number,
    name: string,
    required: boolean
}
export type AddLocationPayload = {
    name: string,
    streetLineOne?: string,
    streetLineTwo?: string,
    city?: string,
    state?: string,
    postalCode?: string
    customfields: CustomFieldPayload[]
}
export type AddLocationProps = {
    locationFormFields: any[]
    onSubmit: (data: AddLocationPayload) => Promise<void>
}

const AddLocation = ({ locationFormFields, onSubmit }: AddLocationProps) => {
    const [fields, setFields] = useState<FieldProps<string, any>>();
    const [selectOptions, setSelectOptions] = useState<SelectOption[]>([]);
    const { toggleDrawer } = useSlideInContext();

    useEffect(() => {
        setFields(() => locationFormFields.map((field) => {
            if (field.name != "roleType") return field; //TODO: NEED TO ITERATE ON THE CUSTOM FIELD
        }))
    }, [])

    const handleSubmit = async (values: AddLocationPayload) => {
        await onSubmit(values)
        toggleDrawer()
    }
    return (
        <div style={{ color: "#fff", paddingTop: "16px" }}>
            <Form
                initialValues={{ country: "USA" }}
                onSubmit={handleSubmit}
                render={({ handleSubmit, form, submitting }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid style={{ marginTop: 0 }} container spacing={4} rowSpacing={4}>
                            {fields && fields.map((field: FieldProps<string, any>, i: number) => (
                                <Grid
                                    key={`add-location-field${i + 20}`}
                                    size={field.grid.xs}
                                >
                                    <Field
                                        autoComplete="off"
                                        {...field} />
                                </Grid>
                            ))}
                            <Grid size={6}>
                                <Field name="country"
                                    label="Country"
                                    type="input"
                                    component={InputField}
                                    InputLabelProps={{ shrink: true }}
                                    required
                                    disabled
                                    fullWidth />
                            </Grid>
                            <Grid
                                size={12}
                                sx={{ display: "flex", justifyContent: "flex-start" }}
                            >
                                <LoadingButton
                                    loading={submitting}
                                    disableElevation
                                    variant="contained"
                                    size="large"
                                    type="submit"
                                    onClick={() => form.submit()}
                                    sx={{
                                        backgroundColor: "primary.main",
                                        "&:hover": {
                                            backgroundColor: "primary.light",
                                        },
                                    }}
                                >
                                    Save
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </form>)
                } />
        </div>
    )

}

export default AddLocation